<a *ngIf="invoice_model" class="grid-link" [routerLink]="['/property-invoice', invoice_model.id]">{{ invoice_model.invoice_number }}</a>
